const iconWidth = 44

const useStyles = {
  iconContainer: {
    width: iconWidth,
  },
  textContainer: {
    width: `calc(100% - ${iconWidth}px)`,
    wordWrap: 'break-word',
  },
}
export default useStyles
